import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { fetchCollection } from '@/lib/api';
import { ProductCard } from '@/components/ProductCard';
import { ProductGridSkeleton } from '@/components/ProductCardSkeleton';
import { Footer } from '@/components/Footer';
import { Badge } from '@/components/ui/badge';

const CollectionDetailPage = () => {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchCollection(slug).then(setData).finally(() => setLoading(false));
  }, [slug]);

  return (
    <div>
      <div className="max-w-6xl mx-auto px-4 md:px-6 pt-3">
        <Link to="/collections" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
          <ChevronLeft className="w-4 h-4" /> All collections
        </Link>
      </div>
      {data && (
        <section className="bb-cloud-bg mt-2">
          <div className="max-w-6xl mx-auto px-4 md:px-6 py-6 grid md:grid-cols-2 gap-5 items-center">
            <div>
              <Badge className="bg-white border-0 rounded-full text-xs">{data.collection.audience === 'corporate' ? 'Corporate' : data.collection.audience === 'kids' ? 'For Kids' : 'For Everyone'}</Badge>
              <h1 className="font-display text-3xl md:text-4xl font-bold mt-2">{data.collection.name}</h1>
              <p className="text-base text-foreground/80 mt-1">{data.collection.tagline}</p>
              <p className="text-sm text-foreground/70 mt-2">{data.collection.description}</p>
            </div>
            <div className="rounded-2xl overflow-hidden bb-shadow-soft">
              <img src={data.collection.image} alt={data.collection.name} className="w-full aspect-[4/3] object-cover" />
            </div>
          </div>
        </section>
      )}
      <section className="max-w-6xl mx-auto px-4 md:px-6 mt-5">
        {loading ? <ProductGridSkeleton count={6} /> : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
            {(data?.products || []).map((p) => <ProductCard key={p.slug} product={p} />)}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
};

export default CollectionDetailPage;
